import { render, staticRenderFns } from "./Wisc.vue?vue&type=template&id=5a997c00&lang=true"
import script from "./Wisc.vue?vue&type=script&lang=js"
export * from "./Wisc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports